import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { MonitorTaskProductListData } from '../../../../features/price-monitoring-tasks/models/MonitorTaskProductListData';
import { MonitorTaskProductListDataFilter } from '../../../../features/price-monitoring-tasks/models/MonitorTaskProductListDataFilter';
import { MonitorPriceStatusEnum } from '../../../../features/ambassador-monitoring-tasks/models/enums/MonitorPriceStatusEnum';
import { MonitorPriceFormComponent } from '../monitor-price-form/monitor-price-form.component';
import { MatDialog } from '@angular/material/dialog';
import { MonitorTaskService } from '../../../services/monitor-task.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-monitor-task-products',
  standalone: false,
  templateUrl: './monitor-task-products.component.html'
})
export class MonitorTaskProductsComponent implements OnInit, OnDestroy {
  @Input({ required: true }) taskId: number;
  dataLoading = true;
  loading = false;
  pageIndex = 0;
  pageCount = 0;
  pageSize = 10;
  imagePreview: any;
  recordsData: MonitorTaskProductListData = new MonitorTaskProductListData();
  filterModel: MonitorTaskProductListDataFilter = new MonitorTaskProductListDataFilter();
  monitorPriceStatusEnum = MonitorPriceStatusEnum
  refreshSub: Subscription[] = [];
  subscriptions: Subscription[] = [];
  constructor(
    public dialog: MatDialog,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private service: MonitorTaskService,
    private el: ElementRef
  ) { }

  ngOnInit() {
    this.getAll();

    this.refreshSub.push(
      this.service.refreshProducts.subscribe(data => {
        if (data) {
          this.getAll({ pageIndex: this.pageIndex, pageSize: this.pageSize });
        }
      })
    )
  }

  getAll(event: any = null) {
    this.filterModel.taskId = this.taskId;
    this.filterModel.pageSize = this.pageSize;
    this.dataLoading = true;
    if (event) {
      this.pageIndex = event.pageIndex;
      this.filterModel.pageSize = event.pageSize;
      this.pageSize = event.pageSize;
      this.scrollToTop();
    } else {
      this.pageIndex = 0;
    }
    this.filterModel.pageNumber = this.pageIndex + 1;
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions.push(
      this.service.getMonitorTaskProductDetails(this.filterModel).subscribe(
        (data: any) => {
          this.dataLoading = false;
          if (data) {
            this.recordsData = data;
            this.pageCount = Math.ceil(this.recordsData.totalProductsCount / this.filterModel.pageSize);
          }
        },
        (error: any) => {
          this.recordsData = new MonitorTaskProductListData();
          this.dataLoading = false;
        })
    )
  }

  private scrollToTop() {
    this.el.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  openForm(monitorTaskProductId: number) {
    const dialogRef = this.dialog.open(MonitorPriceFormComponent, {
      width: '540px',
      data: {
        taskId: this.taskId,
        monitorTaskProductId,

      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAll({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        });
        this.service.refreshDetails.next(true);
      }
    });
  }

  filePreview(monitorTaskProductId: number) {

    this.service.getetMonitorTaskProductAttachments(monitorTaskProductId).subscribe(
      (data: any) => {
        if (data) {
          this.imagePreview = data[0].path
          this.renderer.addClass(document.body, 'overflow-hidden');
        }
      }
    ), error => {

    }
  }

  closePreview() {
    this.imagePreview = '';
    this.renderer.removeClass(document.body, 'overflow-hidden');
  }

  ngOnDestroy() {
    this.service.refreshProducts.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.refreshSub.forEach(sub => sub.unsubscribe());
  }
}
